var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FactsheetBar',{attrs:{"title":_vm.title,"icon":_vm.icon,"title-right":_vm.titleRight,"icon-right":_vm.iconRight}}),_c('div',{staticClass:"Main__Content d-flex justify-content-between"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }